import { Box, Group, Stack, UnstyledButton } from "@mantine/core";
import {
  IconBrain,
  IconBrush,
  IconCodeDots,
  IconDatabase,
  IconDeviceMobile,
  IconSearch,
  IconServer,
  IconShieldCheck,
  IconSparkles,
  IconTool,
  IconUsers,
} from "@tabler/icons-react";
import { Link } from "gatsby";
import React from "react";

import { CardScroll, cardScrollClasses, Text, Title } from "@components";

const services = [
  {
    title: "AI Services",
    href: "/ai",
    icon: <IconBrain size={40} />,
  },
  {
    title: "Web Design",
    href: "/services/web-design",
    icon: <IconBrush size={40} />,
  },
  {
    title: "Web Development",
    href: "/services/web-development",
    icon: <IconCodeDots size={40} />,
  },
  {
    title: "Search Engine Optimization",
    href: "/services/seo",
    icon: <IconSearch size={40} />,
  },
  {
    title: "DevOps",
    href: "/services/devops",
    icon: <IconServer size={40} />,
  },
  {
    title: "Enterprise Software",
    href: "/services/enterprise-software",
    icon: <IconDatabase size={40} />,
  },
  {
    title: "CMS Solutions",
    href: "/services/cms",
    icon: <IconTool size={40} />,
  },
  {
    title: "Agency Partnerships",
    href: "/services/agency-partnerships",
    icon: <IconUsers size={40} />,
  },
  {
    title: "Interactive Experiences",
    href: "/services/interactive-experiences",
    icon: <IconSparkles size={40} />,
  },
  {
    title: "Custom Apps",
    href: "/services/custom-apps",
    icon: <IconDeviceMobile size={40} />,
  },
  {
    title: "Website Security",
    href: "/services/website-security",
    icon: <IconShieldCheck size={40} />,
  },
];

export function OurServices() {
  const sidebarContent = (
    <Stack h="100%" justify="space-between">
      <Title order={2} c="fontLight">
        Our
        <br />
        services
      </Title>
    </Stack>
  );

  const renderService = (service: (typeof services)[0]) => (
    <UnstyledButton component={Link} to={service.href} c="white">
      <Group wrap="nowrap" h="100%" justify="center">
        <Box className={cardScrollClasses.cardHighlight} />

        <Stack p="xxl" w="100%" justify="center" gap="md" align="center">
          {service.icon}

          <Text
            fw="600"
            size={{ base: "md", xs: "lg" }}
            c="fontLight"
            ta="center"
          >
            {service.title}
          </Text>
        </Stack>
      </Group>
    </UnstyledButton>
  );

  return (
    <CardScroll
      title="Our services"
      sidebarContent={sidebarContent}
      data={services}
      renderItem={renderService}
      cardProps={{ miw: 320, maw: 320, mih: 280, p: "xs" }}
      cardClassName={cardScrollClasses.card}
    />
  );
}
